package org.lennycodes.gradematewebsite

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.window
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*
import org.lennycodes.portfolio.styles.*
var showChrome by mutableStateOf(
    window.location.pathname !in listOf("/login", Routes.admin)
)
@Page("/login")
@Composable
fun Login() {
    val ctx = rememberPageContext()
    val scope = rememberCoroutineScope()
    var email by remember { mutableStateOf("") }
    var password by remember { mutableStateOf("") }
    var errorMessage by remember { mutableStateOf("") }
    var isLoading by remember { mutableStateOf(false) }
// Login.kt, at the top of Login()
    DisposableEffect(Unit) {
        showChrome = false
        onDispose { showChrome = true }
    }
    Column(
        modifier = Modifier.padding(24.px).then(LoginPageStyle.toModifier()),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center
    ) {
        Column(
            modifier = Modifier.padding(40.px, 32.px)
                .then(LoginCardStyle.toModifier()),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Image(
                src = "grademate.png",
                alt = "grademate Logo",
                width = 128,
                height = 64,
                modifier = LoginLogoStyle.toModifier()
            )
            H3(attrs = LoginTitleStyle.toAttrs()) {
                Text("Welcome to GradeMate")
            }
            P(attrs = LoginSubtitleStyle.toAttrs()) {
                Text("Sign in to continue")
            }

            Div(attrs = LoginFieldGroupStyle.toAttrs()) {
                Label(forId = "email", attrs = LoginLabelStyle.toAttrs()) {
                    Text("Email")
                }
                Input(
                    type = InputType.Email,
                    attrs = Modifier
                        .padding(12.px, 14.px)
                        .then(LoginInputStyle.toModifier())
                        .toAttrs {
                            id("email")
                            placeholder("you@example.com")
                            value(email)

                            onInput {
                                email = it.value
                            }

                            if (isLoading) {
                                disabled()
                            }
                        }
                )
            }

            Div(attrs = LoginFieldGroupStyle.toAttrs()) {
                Label(forId = "password", attrs = LoginLabelStyle.toAttrs()) {
                    Text("Password")
                }
                Input(
                    type = InputType.Password,
                    attrs = (Modifier
                        .padding(12.px, 14.px)
                        .then(LoginInputStyle.toModifier()))
                        .toAttrs {
                            id("password")
                            placeholder("••••••••")
                            value(password)
                            onInput { password = it.value }

                            if (isLoading) disabled()
                        }
                )
            }

            Button(
                modifier = Modifier.padding(14.px).then(LoginButtonStyle.toModifier())
                    .styleModifier { property("opacity", if (isLoading) "0.7" else "1") },
                enabled = !isLoading,
                onClick = {

                    scope.launch {
                        errorMessage = ""
                        isLoading = true
                        try {
                            val success = login(email.trim(), password)
                            if (success) {
                                console.log("Login successful")
                                errorMessage = ""
                                ctx.router.navigateTo(Routes.admin)
                            } else {
                                console.log("Login failed")
                                errorMessage = "Invalid email or password"
                            }
                        } catch (e: Throwable) {
                            console.error("Login error:", e.message)
                            errorMessage = "Login failed. Please try again."
                        } finally {
                            isLoading = false
                        }


                    }

                }
            ) {
                Text(if (isLoading) "Signing in..." else "Login")
            }

            if (errorMessage.isNotEmpty()) {
                Div(attrs = Modifier.padding(10.px, 12.px)
                    .then(LoginErrorStyle.toModifier()).toAttrs()){
                    Text(errorMessage)
                }
            }
        }
    }
}